import React from "react";
import { isEmpty } from "../../Util";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Layout = (prop) => {

    const isWhiteLabel = useSelector((state) => state.Reducer.settings?.isWhiteLabel)
    const { t } = useTranslation();

    return (
        <>
            <div className={prop.isLarge ? "container large" : "container not-large" }>
                <main role="main">
                    { 
                        (!prop.hideLogo && !isEmpty(isWhiteLabel) && !isWhiteLabel) &&
                        <div className=''>
                            <div className="logo-line-container mb-4">

                                <img src={process.env.PUBLIC_URL + 'images/az-pay-logo.svg'}
                                    alt="Allianz trade"
                                    className={prop.centerLogo ? 'az-pay-center' : 'az-pay-left'} />
                                {
                                    !prop.centerLogo && 
                                    
                                    <div className="az-header-container">
                                        {prop.isLarge && <div className="horizontal-line"></div>}
                                        <span className="az-layout-label">{t('checkOptions.header')}</span>
                                    </div>
                                    
                                }
                            </div>
                        </div>
                    }
                    {prop.children}
                </main>
            </div>
        </>
    )
}

export default Layout;